export const GET_DATES_WITH_MEMORIES = 'GET_DATES_WITH_MEMORIES';
export const SET_SELECTED_DATE = 'SET_SELECTED_DATE'
export const ADD_MEMORIES_OF_SELECTED_DATE = 'ADD_MEMORIES_OF_SELECTED_DATE'
